export function getStorageAndParse(key) {
  const storage = localStorage.getItem(key);
  return JSON.parse(storage);
}

export function stringifyAndSetStorage(key, value) {
  const storage = JSON.stringify(value);
  localStorage.setItem(key, storage);
}

export function deleteStorageItem(key) {
  localStorage.removeItem(key);
}



// WEBPACK FOOTER //
// ./src/util/storage.js